$(document).ready(function () {
  const videos = document.querySelectorAll("#video");
  const playButtons = document.querySelectorAll(".play-button");

  playButtons.forEach((playButton, index) => {
    const video = videos[index];

    playButton.addEventListener("click", () => {
      if (video.paused) {
        video.play();
        playButton.style.display = "none";
      } else {
        video.pause();
        playButton.style.display = "flex";
      }
    });

    video.addEventListener("ended", () => {
      playButton.style.display = "flex";
    });

    video.addEventListener("click", () => {
      if (!video.paused) {
        video.pause();
        playButton.style.display = "flex";
      }
    });
  });

  // document.querySelectorAll(".testimonial_review_row").forEach((slider) => {
  //   new Swiper(slider, {
  //     slidesPerView: 1,
  //     spaceBetween: 10,
  //     freeMode: true,
  //     loop: true,
  //     // speed: 5000,
  //     // autoplay: {
  //     //   delay: 0,
  //     //   disableOnInteraction: false,
  //     // },
  //     breakpoints: {
  //       576: {
  //         slidesPerView: 1,
  //         spaceBetween: 30,
  //         loop: true,
  //       },
  //       768: {
  //         slidesPerView: 2,
  //         spaceBetween: 30,
  //         loop: true,
  //       },
  //       1024: {
  //         slidesPerView: 3,
  //         spaceBetween: 30,
  //         loop: true,
  //       },
  //     },
  //   });

  var swiper = new Swiper(".collection-media-item .swiper-container", {
    pagination: {
      el: ".collection-media-item .swiper-pagination",
      clickable: true,
    },
    parallax: true,
    speed: 600,
    spaceBetween: 16,
  });
});

$(document).ready(function () {
  $(".testimonial_review_row.index-1 .review_data_grid").slick({
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 5000,
    arrows: false,
    swipe: false,
    slidesToShow: 2.5,
    cssEase: "linear",
    pauseOnFocus: false,
    pauseOnHover: false,
    dots: false,
    infinite: true,
  });
$(".testimonial_review_row.index-2 .review_data_grid").slick({
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 5000,
    centerMode: true,
    centerPadding:'150px',
    arrows: false,
    swipe: false,
    slidesToShow: 2,
    cssEase: "linear",
    pauseOnFocus: false,
    pauseOnHover: false,
    dots: false,
    infinite: true,
  });
  // $(".testimonial_review_row.rtl .review_data_grid").slick({
  //   autoplay: true,
  //   autoplaySpeed: 1000,
  //   speed: 5000,
  //   arrows: false,
  //   swipe: false,
  //   slidesToShow: 2.5,
  //   cssEase: "linear",
  //   pauseOnFocus: false,
  //   pauseOnHover: false,
  //   dots: false,
  //   infinite: true,
  //   rtl: true,
  // });
});

// $(document).ready(function () {
//   var $iconInnerDivs = $(".work-cycle-icon-inner");
//   var currentIndex = 0;

//   function cycleActiveClass() {
//     // Remove the active class from all inner divs
//     $iconInnerDivs.removeClass("active");

//     // Add the active class to the current index
//     $iconInnerDivs.eq(currentIndex).addClass("active");

//     // Increment the index
//     currentIndex++;

//     // Reset to the first index if at the end
//     if (currentIndex >= $iconInnerDivs.length) {
//       currentIndex = 0;
//     }
//   }

//   setInterval(cycleActiveClass, 30000);

//   cycleActiveClass();
// });

$(document).ready(function () {
  $(".label_btn").click(function () {
    $(".label_btn").removeClass("active_label");

    $(this).addClass("active_label");

    if ($(this).hasClass("label_1")) {
      $(".package_block_single_ad_content, .single_ad_img").addClass(
        "active_label"
      );
      $(".package_block_vertical_ad_content, .vertical_ad_img").removeClass(
        "active_label"
      );
    } else if ($(this).hasClass("label_3")) {
      $(".package_block_vertical_ad_content, .vertical_ad_img").addClass(
        "active_label"
      );
      $(".package_block_single_ad_content, .single_ad_img").removeClass(
        "active_label"
      );
    }
  });
});

$(document).ready(function () {
  var $iconInnerDivs = $(".work-cycle-icon-inner");
  var blocks = [
    ".package_block",
    ".preferences_block",
    ".prepare_order_block",
    ".download_ads_block",
  ];
  var currentIndex = 0;
  var intervalDuration = 30000;
  var autoCycle;

  function updateActiveClasses(index) {
    $iconInnerDivs.removeClass("active");
    $(blocks.join(",")).removeClass("active_block");

    $iconInnerDivs.eq(index).addClass("active");

    $(blocks[index]).addClass("active_block");
  }

  function startAutoCycle() {
    autoCycle = setInterval(function () {
      currentIndex = (currentIndex + 1) % $iconInnerDivs.length;
      updateActiveClasses(currentIndex);
    }, intervalDuration);
  }

  updateActiveClasses(currentIndex);
  startAutoCycle();

  $iconInnerDivs.on("click", function () {
    clearInterval(autoCycle);

    currentIndex = $iconInnerDivs.index($(this));

    updateActiveClasses(currentIndex);

    startAutoCycle();
  });
});
